"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = FacebookSquare;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function FacebookSquare(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "Facebook"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "facebook-square"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M81.429,92.5H66.2A2.5,2.5,0,0,1,63.7,90V58.357a2.5,2.5,0,0,1,2.5-2.5h8.622l.911-7.071H66.2a2.5,2.5,0,0,1-2.5-2.5V38.571c0-2.071,0-8.375,8.483-8.375h3.892V24.185c-1.681-.127-4.106-.256-6.821-.256-8.284,0-13.036,4.907-13.036,13.464V46.3a2.5,2.5,0,0,1-2.5,2.5H45.357v7.071h8.375a2.5,2.5,0,0,1,2.5,2.5V90a2.5,2.5,0,0,1-2.5,2.5H18.571A11.084,11.084,0,0,1,7.5,81.429V18.571A11.084,11.084,0,0,1,18.571,7.5H81.429A11.084,11.084,0,0,1,92.5,18.571V81.429A11.084,11.084,0,0,1,81.429,92.5ZM68.7,87.5H81.429A6.079,6.079,0,0,0,87.5,81.429V18.571A6.079,6.079,0,0,0,81.429,12.5H18.571A6.079,6.079,0,0,0,12.5,18.571V81.429A6.079,6.079,0,0,0,18.571,87.5H51.232V60.875H42.857a2.5,2.5,0,0,1-2.5-2.5V46.3a2.5,2.5,0,0,1,2.5-2.5h8.357V37.393c0-11.217,7.08-18.464,18.036-18.464a89.092,89.092,0,0,1,9.641.5,2.5,2.5,0,0,1,2.18,2.48V32.7a2.5,2.5,0,0,1-2.5,2.5H72.179c-3.314,0-3.483.867-3.483,3.375v5.215h9.875a2.5,2.5,0,0,1,2.48,2.819L79.5,58.676a2.5,2.5,0,0,1-2.479,2.181H68.7Z"
  })))));
}